import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const FILE_SIZE_RULE_EDITOR_CLASS_NAME = 'FileSizeRuleEditor';
export const FILE_SIZE_RULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type FileSizeRuleEditorClassSlot =
	(typeof FILE_SIZE_RULE_EDITOR_CLASS_SLOTS)[number];

export interface FileSizeRuleEditorClasses {
	root: string;
}

export type FileSizeRuleEditorClassKey = keyof FileSizeRuleEditorClasses;

export const getFileSizeRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(FILE_SIZE_RULE_EDITOR_CLASS_NAME, slot);

export const fileSizeRuleEditorClasses: FileSizeRuleEditorClasses =
	generateUtilityClasses(FILE_SIZE_RULE_EDITOR_CLASS_NAME, ['root']);

export default fileSizeRuleEditorClasses;
